<template>
    <div
        class="tab-proposals"
        v-if="!loading"
    >
        <Banner class="folder"/>
        <Folder
            class="folder"
            title="Активности">
            <Activities/>
        </Folder>
        <!-- <Folder
            v-if="isStudent"
            class="folder"
            title="Чат с наставником">
            <MentorChat/>
        </Folder> -->
        <Folder
            class="folder"
            title="Задачи">
            <Tasks/>
        </Folder>
        <Folder
            class="folder"
            title="Учебные материалы">
            <Files/>
        </Folder>
        <Folder
            class="folder"
            title="Новости">
            <News/>
        </Folder>
        <Folder
            class="folder"
            title="Опросы">
            <Surveys/>
        </Folder>
    </div>
</template>

<script>
import Folder from '../../UI/Folder';
import Banner from './tab-mentoring/Banner';
import Activities from './tab-mentoring/Activities';
// import MentorChat from './tab-mentoring/MentorChat';
import Tasks from './tab-mentoring/Tasks';
import Files from './tab-mentoring/Files';
import News from './tab-mentoring/News';
import Surveys from './tab-mentoring/Surveys';

import {mapActions, mapGetters, mapState} from 'vuex';

const actions = [
    'loadGroup',
];

export default {
    name: 'TabMentoring',
    data: () => ({
        loading: true,
    }),
    computed: {
        ...mapGetters('mentoring', [
            'isStudent',
            'isMentoringParticipant',
        ]),
    },
    methods: {
        ...mapActions('mentoring', actions),
    },
    async created() {
        this.loading = true;
        await this.loadGroup();
        this.$route.meta.unauthorizedRedirect(this.$router);
        this.loading = false;
    },
    components: {
        Folder,
        Banner,
        Activities,
        // MentorChat,
        Tasks,
        Files,
        News,
        Surveys,
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';
@import "../../../styles/variables";

.folder {
    margin-bottom: rem(32);
    @media (max-width: $vm) {
        margin-bottom: mrem(24);
    }
}
</style>
